import { render, staticRenderFns } from "./ChartRehabWidgetSymmetry.vue?vue&type=template&id=e474e986&scoped=true&"
import script from "./ChartRehabWidgetSymmetry.vue?vue&type=script&lang=ts&"
export * from "./ChartRehabWidgetSymmetry.vue?vue&type=script&lang=ts&"
import style0 from "./ChartRehabWidgetSymmetry.vue?vue&type=style&index=0&id=e474e986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e474e986",
  null
  
)

export default component.exports